module.exports = __webpack_public_path__ + "static/img/17.09738e2e.png";